import { useEffect, useState } from "react";

function DescriptionInput({ data, label = "Description" ,durationCompensationAppointment, setDurationCompensationAppointment, setFormErrors, formErrors }) {
    const [selectedDescription, setSelectedDescription] = useState("");
    const [error, setError] = useState("");

    useEffect(() => {
        // Synchronize local error state with `formErrors`
        if (formErrors && formErrors[data.id]?.description) {
            setError(formErrors[data.id].description);
        } else {
            setError(""); // Clear local error if not in formErrors
        }
    }, [formErrors]);
    
    useEffect(() => {
        setSelectedDescription(data?.description || "");
    }, [data]);


    const handleDescriptionChange = (e) => {
        const newDescription = e.target.value;
        setSelectedDescription(newDescription);

        if (newDescription === "") {
            // Set error for an empty description field
            setError("This field is required");
            setFormErrors((prevErrors) => ({
                ...prevErrors,
                [data.id]: {
                    ...prevErrors[data.id],
                    description: "This field is required", // Scope to `description`
                },
            }));
        } else {
            // Clear error if description is valid
            setError("");
            setFormErrors((prevErrors) => {
                const { [data.id]: currentErrors, ...rest } = prevErrors;
                if (currentErrors) {
                    const { description, ...otherErrors } = currentErrors;
                    if (Object.keys(otherErrors).length === 0) {
                        return rest; // Remove `data.id` if no other errors exist
                    }
                    return {
                        ...rest,
                        [data.id]: otherErrors, // Keep other errors, remove `description`
                    };
                }
                return rest;
            });
        }

        // Update the `durationCompensationAppointment` array
        const updatedAppointments = durationCompensationAppointment.map((appointment) => {
            if (appointment.id === data.id) {
                return { ...appointment, description: newDescription };
            }
            return appointment;
        });

        setDurationCompensationAppointment(updatedAppointments);
    };
    return (

        <>
            <div className="col-12">
                <label htmlFor="exampleInputEmail1" className="form-label appointment-duration-compensation">{`${data?.sample_id == 2 ? "Urine Time Description" : "Stool Time Description"}`}<span className="text-danger"> *</span></label>
            </div>
            <div className="col-md-12">
                <div className="input-group mb-3">

                    <input type="text" className="form-control" onChange={handleDescriptionChange} value={selectedDescription} placeholder="Type here.." aria-label="Amount (to the nearest dollar)" />
                </div>
                {error && (<div>
                    <p name="wbs_element" component="div" className="text-danger" >{error}</p>
                </div>)}
            </div>
        </>
    );

}
export default DescriptionInput
